[
  {
    "code": "LC-01",
    "name": "Anse la Raye"
  },
  {
    "code": "LC-12",
    "name": "Canaries"
  },
  {
    "code": "LC-02",
    "name": "Castries"
  },
  {
    "code": "LC-03",
    "name": "Choiseul"
  },
  {
    "code": "LC-05",
    "name": "Dennery"
  },
  {
    "code": "LC-06",
    "name": "Gros Islet"
  },
  {
    "code": "LC-07",
    "name": "Laborie"
  },
  {
    "code": "LC-08",
    "name": "Micoud"
  },
  {
    "code": "LC-10",
    "name": "Soufrière"
  },
  {
    "code": "LC-11",
    "name": "Vieux Fort"
  }
]